// Free-text coming out of the dashboard API (corrective `issue`, inspection
// `question`/`subCategory`, master-table values) is stored as Quill rich text,
// so it arrives as markup: "<p>corrective 3 with&nbsp;open and action</p>".
// The dashboard shows these in DataGrid cells, single-line ellipsised cells and
// `title=` tooltips, all of which need a plain string — so we flatten to text
// rather than parsing to React nodes the way parseHtmlContent does elsewhere.
//
// Display-only. Never pass a value through this on its way back to the API:
// drill-down filters match the exact stored string server-side.

// `<` followed by a letter, `!` or `/` — so "5 < 10" is not mistaken for a tag.
const TAG_PROBE = /<[a-z!/][^>]*>/i;
// A complete named or numeric entity — so a bare "&" in "Smith & Sons" is left alone.
const ENTITY_PROBE = /&(?:[a-z][a-z0-9]{1,31}|#\d{1,7}|#x[0-9a-f]{1,6});/i;

const MAX_DECODE_PASSES = 2; // one extra pass covers double-encoded ("&lt;p&gt;") rows

function decodeAndStrip(str) {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return doc.body ? doc.body.textContent || "" : "";
}

export function toPlainText(value) {
  if (typeof value !== "string" || value === "") return value;
  if (!TAG_PROBE.test(value) && !ENTITY_PROBE.test(value)) return value;

  let out = value;
  for (let i = 0; i < MAX_DECODE_PASSES; i += 1) {
    const next = decodeAndStrip(out);
    if (next === out) break;
    out = next;
  }
  // `\s` matches the   that &nbsp; decodes to, so this normalises it too.
  return out.replace(/\s+/g, " ").trim();
}
